import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_PROSPECTION } from "../prospection.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateProspectionInput } from "../../../__generated__/globalTypes";
import {
  CreateProspectionMutation,
  CreateProspectionMutationVariables,
} from "../../../__generated__/CreateProspectionMutation";

interface IProps {
  defaultValues: DeepPartial<CreateProspectionInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateProspection = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateProspectionInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateProspectionMutation,
    CreateProspectionMutationVariables
  >(CREATE_PROSPECTION, {
    refetchQueries: ["ProspectionsQuery"],
    update(cache) {
      evictFields(cache, ["prospection", "prospections"]);
    },
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createProspection?.ok) {
        onCompleted(data.createProspection.id);
      } else {
        throw Error(data?.createProspection?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
